import React, { Component } from 'react';

import { connect } from 'react-redux';

import * as NotificationsConfig from 'notifications_config/components';
import NotificationConfigFormHandlers from 'notifications_config/containers/NotificationConfigFormHandlers';

import { getVisibleCustomFieldsEmployees } from 'custom_fields_employees/selectors'; //Groups
import { getVisibleGroups } from 'groups/selectors'; //Groups

import {
  getIsSaving,
  getIsFetching,
  getEditing,
  getIsFetchingConfig,
  getVisibleNotificationsConfig,
} from 'notifications_config/selectors';
import { getVisibleDepreciations } from 'selectors/lists';
import { getCompany, getSubcompany } from 'auth/selectors';

class NotificationsConfigFormContainer extends Component {
  render = () => (
    <NotificationConfigFormHandlers
      render={({
        isSubmitted,
        isSaving,
        handleValueChange,
        handleValidation,
        handleSubmit,
        handleRemoveCustomField,
        handleGroupChange, //Groups
        handleCustomFieldChange, //Groups
        handleAddCustomField,
        notifications_elementsBySections,
        allSections,
        handleAddToNotify,
        handleRemoveToNotify,
        handleCheckSection,
        handleCheckPermission,
        handleClickPermissionRow,
      }) => (
        <NotificationsConfig.FormView
          subcompany={this.props.subcompany}
          isSubmitted={isSubmitted}
          isSaving={isSaving}
          isFetching={this.props.isFetching}
          handleValueChange={handleValueChange}
          handleValidation={handleValidation}
          notifications_elementsBySections={notifications_elementsBySections}
          allSections={allSections}
          handleAddToNotify={handleAddToNotify}
          handleRemoveToNotify={handleRemoveToNotify}
          handleCheckSection={handleCheckSection}
          handleCheckPermission={handleCheckPermission}
          handleClickPermissionRow={handleClickPermissionRow}
          handleSubmit={handleSubmit}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={this.props.groups} //Groups
          handleRemoveCustomField={handleRemoveCustomField}
          handleAddCustomField={handleAddCustomField}
          depreciations={this.props.depreciations}
          company={this.props.company}
          notification_config={this.props.notification_config}
          notificationConfig={this.props.notificationConfig}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  isSaving: getIsSaving(state),
  isFetching: getIsFetching(state),
  isFetchingConfig: getIsFetchingConfig(state),
  notificationConfig: getEditing(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
  customfields: getVisibleCustomFieldsEmployees(state), //Groups
  groups: getVisibleGroups(state), //Groups
  notification_config: getVisibleNotificationsConfig(state),
  depreciations: getVisibleDepreciations(state),
});

export default connect(mapStateToProps, null)(NotificationsConfigFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/containers/NotificationsConfigFormContainer.js